import { BackButton, Divider, Form, FormDate, FormDropDown, Header, useAlignments, useSizes } from 'metrix-common3';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileDriverSuspension = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    const convictions = [];
    if (props.convictions) {
        props.convictions.forEach((conviction) => {
            convictions.push({ code: conviction.value, value: conviction.code });
        });
    }

    return (
        <React.Fragment>
            <BackButton clickEvent={props.backEvent} />
            <Divider top={sizes.md} />
            <Header
                size={sizes.md}
                textAlign={alignments.left}
                text={<FormattedMessage id='Profile_Drivers_Suspension.drivingSuspension' />}
            />
            <Form
                label={<FormattedMessage id='Profile_Drivers_Suspension.drivingSuspensionDetails' />}
                allowEdit={props.allowEdit}
                saveEvent={() => props.doUpsertPolicy()}
                cancelEvent={() => props.doGetPolicy()}
            >
                <FormDate
                    label={<FormattedMessage id='Profile_Drivers_Suspension.startDate' />}
                    value={props.suspension?.startDate}
                    changeEvent={(value) => props.doReducePolicyElement({ code: `${props.dotProp}startDate`, value })}
                    culture={props.context.session.culture}
                    mode='past'
                    allowEdit
                />
                <FormDate
                    label={<FormattedMessage id='Profile_Drivers_Suspension.endDate' />}
                    value={props.suspension?.endDate}
                    changeEvent={(value) => props.doReducePolicyElement({ code: `${props.dotProp}endDate`, value })}
                    culture={props.context.session.culture}
                    mode='past'
                    allowEdit
                />
                <FormDate
                    label={<FormattedMessage id='Profile_Drivers_Suspension.reinstatementDate' />}
                    value={props.suspension?.reinstatementDate}
                    changeEvent={(value) =>
                        props.doReducePolicyElement({ code: `${props.dotProp}reinstatementDate`, value })
                    }
                    culture={props.context.session.culture}
                    mode='past'
                    allowEdit
                />
                <FormDropDown
                    label={<FormattedMessage id='Profile_Drivers_Suspension.relatedConviction' />}
                    value={
                        props.suspension && {
                            code: props.suspension.relatedEvent,
                        }
                    }
                    references={convictions}
                    // biome-ignore lint/suspicious/noEmptyBlockStatements: noop callback for referencesEvent contract
                    referencesEvent={() => {}}
                    changeEvent={(value) => {
                        props.doReducePolicyElement({ code: `${props.dotProp}relatedEvent`, value: value.code });
                    }}
                    allowEdit
                />
            </Form>
        </React.Fragment>
    );
};

export default ProfileDriverSuspension;
